module.exports = __webpack_public_path__ + "static/media/logistic.3c578956.jpg";